import forEach from 'lodash/forEach';
import Http from '../Http';
import {
  addVersion,
} from '../HelperAPI';
import { gaEvent } from '../../helpers/Analytics';
import MessageRequest from '../../models/MessageRequest';

const baseUrl = `${process.env.VAPI_BASE_URL}/messagerequests`;

export default {
  list: (data, options, category) => {
    options = addVersion('8.31.0', options);
    return Http.post(`${baseUrl}/${category}`, data, options);
  },
  listCuration: async (data, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.post(`${baseUrl}/curation`, data, options);

    return {
      ...response,
      data: response.data.map(item => {
        forEach(item.media, (item1) => {
          item1.url = Http.cloudfront(item1.url);
        });
        item.url = Http.cloudfront(item.url);
        return item;
      }),
    };
  },
  listProcessing: async (data, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.post(`${baseUrl}/processing`, data, options);

    return {
      ...response,
      data: response.data.map(item => {
        forEach(item.media, (item1) => {
          item1.url = Http.cloudfront(item1.url);
        });
        return {
          ...item,
          roughCutUrl: Http.cloudfront(item.roughCutUrl),
          finalCutUrl: Http.cloudfront(item.finalCutUrl),
          url: Http.cloudfront(item.url),
        };
      }),
    };
  },
  listRough: async (data, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.post(`${baseUrl}/rough`, data, options);

    return {
      ...response,
      data: response.data.map(item => {
        forEach(item.media, (item1) => {
          item1.url = Http.cloudfront(item1.url);
        });
        return {
          ...item,
          roughCutUrl: Http.cloudfront(item.roughCutUrl),
        };
      }),
    };
  },
  listReview: async (data, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.post(`${baseUrl}/review`, data, options);

    return {
      ...response,
      data: response.data.map(item => {
        forEach(item.media, (item1) => {
          item1.url = Http.cloudfront(item1.url);
        });
        return {
          ...item,
          finalCutUrl: Http.cloudfront(item.finalCutUrl),
        };
      }),
    };
  },
  getById: async (id, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.get(`${baseUrl}/${id}`, options);
    const activity = response.activity ?? [];

    const data = {
      ...response,
      activity: activity.map(item => {
        const detail = item.detail ?? {};
        forEach(item.media, (item1) => {
          item1.url = Http.cloudfront(item1.url);
        });
        return {
          ...item,
          imageUrl: Http.cloudfront(item.imageUrl),
          detail: {
            ...detail,
            url: Http.cloudfront(detail.url),
          },
        };
      }),
    };

    return new MessageRequest(data);
  },
  getExpandedLocations: async (id, options) => {
    const response = await Http.get(`${baseUrl}/${id}/locations/expanded`, options) ?? [];

    return response.map(item => {
      const locations = item.locations ?? [];

      return {
        ...item,
        imageUrl: Http.cloudfront(item.imageUrl),
        locations: locations.map(location => {
          return {
            ...location,
            imageUrl: Http.cloudfront(location.imageUrl),
          };
        }),
      };
    });
  },
  create: async (data, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.post(baseUrl, data, options);

    gaEvent({
      category: 'message_request',
      action: 'create_message_request',
      label: data.name,
    }, response[0]?.type === 'MESSAGEREQUEST.CREATED');

    return response;
  },
  assignVoiceTalent: (data) => Http.post(`${baseUrl}/${data._id}/assign`, data),
  uploadRough: (id, file, onProgress, options = {}) => {
    options = addVersion('8.31.0', options);
    return Http.postFileUpload(
      `${baseUrl}/${id}/rough`, file, 'media', onProgress, options,
    );
  },
  uploadFinal: (id, file, onProgress, options = {}) => {
    options = addVersion('8.31.0', options);
    return Http.postFileUpload(
      `${baseUrl}/${id}/final`, file, 'media', onProgress, options,
    );
  },
  uploadFinalVisual: (id, file, targetScreen, onProgress, options = {}) => {
    options = addVersion('8.31.0', options);
    return Http.postVisualFileUpload(
      `${baseUrl}/${id}/final`, file, 'media', targetScreen, onProgress, options,
    );
  },
  uploadAttachment: (id, file, onProgress) => Http.postFileUpload(
    `${baseUrl}/${id}/attachment`, file, 'attachment', onProgress,
  ),
  scriptHistory: async (id, options) => {
    const response = await Http.get(`${baseUrl}/${id}/script/history`, options);

    return response.map(item => {
      return {
        ...item,
        userImageUrl: Http.cloudfront(item.userImageUrl),
      };
    });
  },
  uploadHistory: async (id, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.get(`${baseUrl}/${id}/upload/history`, options);

    return response.map(item => {
      return {
        ...item,
        userImageUrl: Http.cloudfront(item.userImageUrl),
        url: Http.cloudfront(item.url),
      };
    });
  },
  rename: (data) => Http.post(`${baseUrl}/${data._id}/name`, data),
  changeDates: (data) => Http.post(`${baseUrl}/${data._id}/dates`, data),
  changePublishMode: (data, options) => {
    options = addVersion('7.39.0', options);
    return Http.post(`${baseUrl}/${data._id}/publishmode`, data, options);
  },
  changeMessageBlocks: (data) => Http.post(`${baseUrl}/${data._id}/messageLists`, data),
  changeScript: (data) => Http.post(`${baseUrl}/${data._id}/script`, data),
  changeInstructions: (data) => Http.post(`${baseUrl}/${data._id}/instructions`, data),
  changeTags: (data) => Http.post(`${baseUrl}/${data._id}/tags`, data),
  changeLocations: (data) => Http.post(`${baseUrl}/${data._id}/locations`, data),
  changeTrackingUrls: (data) => Http.post(`${baseUrl}/${data._id}/trackingurls`, data),
  changeCategory: (data) => Http.post(`${baseUrl}/${data._id}/category`, data),
  addComment: (id, data) => Http.post(`${baseUrl}/${id}/comment`, data),
  modify: (data, options = {}) => {
    options = addVersion('8.1.0', options);
    return Http.put(`${baseUrl}/${data._id}`, data, options);
  },
  reactivate: async (data, options) => {
    options = addVersion('5.36.0', options);

    const response = await Http.post(`${baseUrl}/${data._id}`, data, options);

    gaEvent({
      category: 'message_request',
      action: 'unarchive_message_request',
    }, response[0]?.type === 'MESSAGEREQUEST.REACTIVATED');

    return response;
  },
  deactivate: async (id) => {
    const response = await Http.delete(`${baseUrl}/${id}`);

    gaEvent({
      category: 'message_request',
      action: 'archive_message_request',
    }, response[0]?.type === 'MESSAGEREQUEST.DEACTIVATED');

    return response;
  },
  deactivateBulk: (requests) => Http.delete(baseUrl, {
    requests,
  }),
  deleteAttachment: (id, attachmentId) => Http.delete(`${baseUrl}/${id}/attachment/${attachmentId}`),
  sendApprovalNotification: (id, data) => Http.post(`${baseUrl}/${id}/notification/approve`, data),

  // Segments
  Approval: {
    getApprovers: async (data, options) => {
      const response = await Http.post(`${baseUrl}/approvers`, data, options);

      return response.map(item => {
        return {
          ...item,
          imageUrl: Http.cloudfront(item.imageUrl),
        };
      });
    },
    getPartnerApprovers: async (data, options) => {
      const response = await Http.post(`${baseUrl}/approvers/partner`, data, options);

      return response.map(item => {
        return {
          ...item,
          imageUrl: Http.cloudfront(item.imageUrl),
        };
      });
    },
    requestChanges: (data, options) => {
      options = addVersion('7.34.0', options);
      return Http.post(`${baseUrl}/${data._id}/review`, data, options);
    },
    approve: (data, options) => {
      options = addVersion('7.34.0', options);
      return Http.post(`${baseUrl}/${data._id}/review`, data, options);
    },
  },
};
